// extracted by mini-css-extract-plugin
module.exports = {"thumbnail":"index_thumbnail_27Wkj"};